export enum MeasureScheme {
    default = 'default',
    c_mmhg_mg = 'c_mmhg_mg',
    mpc = 'mpc',
    usa_default = 'usa_default',
}
